module.exports = __webpack_public_path__ + "static/media/icon-linkedin.6dcb5539.svg";